module.exports = __webpack_public_path__ + "img/preferred-servicing@2x.04824626.jpg";